<template>
    <div class="alert border-0" :class="classes" role="alert">
        <Icon v-if="icon" :icon="icon" class="me-1" /><slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            icon: String,
            color: {
                type: String,
                default: 'warning'
            }
        },
        computed: {
            classes: function() {
                return [
                    'alert-' + this.color
                ]
            }
        }
    }
</script>